<app-header></app-header>

<div class="banner-img-name"></div>

<main class="body_section">
    <div class="main">
        <!-- <h3 class="w100 payment-heading main-heading">Make Payment</h3> -->



        <div class="box_row">




            <div>

                <h4 class="payment-h4">Choose Payment Method</h4>

                <div class='faq'>

                    <div class="payment-gateways-container">
                        <ng-container *ngIf="gatewayDetailsList?.length > 0; else noGateways">
                            <ng-container *ngFor="let gateway of gatewayDetailsList; trackBy: trackByGateway">
                                <div class="payment-gateway-option">
                                    <!-- Radio button with unique value -->
                                    <input type="radio" name="paymentMethod" [id]="'gateway-' + gateway.id"
                                        [value]="gateway.id" [(ngModel)]="paymentFormObject.selectedGatewayId"
                                        (ngModelChange)="onPaymentMethodChange(gateway)" class="visually-hidden">

                                    <!-- Visible gateway card -->
                                    <label [for]="'gateway-' + gateway.id" class="gateway-card"
                                        [class.selected]="paymentFormObject.selectedGatewayId === gateway.id">

                                        <div class="gateway-content">
                                            <div class="gateway-info">
                                                <h3 class="gateway-name">{{ gateway.gatewayName }}</h3>
                                                <!-- <p class="gateway-description">
                                                        {{ gateway.transactionFee.parsedValue |
                                                        currency:gateway.currencyCode }}
                                                        transaction fee
                                                    </p> -->
                                            </div>

                                            <div class="gateway-logo">
                                                <img [src]="getGatewayImage(gateway.gatewayName)"
                                                    [alt]="gateway.gatewayName + ' logo'" class="gateway-logo-img">
                                            </div>
                                        </div>
                                    </label>
                                </div>
                            </ng-container>
                        </ng-container>

                        <ng-template #noGateways>
                            <div class="no-gateways-message">
                                No payment options available at this time.
                            </div>
                        </ng-template>
                    </div>



                    <!-- Validation message (shown once at the bottom) -->
                    <!-- <div *ngIf="paymentForm.submitted && paymentForm.invalid" class="error-message">
                            <span *ngIf="paymentForm.controls.paymentMethod?.errors?.required">
                                Please select a payment method
                            </span>
                        </div> -->

                </div>
            </div>
            <div class="info-section">
                <div class="mt15">
                    <h4>Important Instructions</h4>
                    <ol>
                        <!-- <li>This application will expire on {{applicationPaymentDetailsObject.applicationExpiryDate}}.
                            Please make payment before this date.</li> -->
                        <li>Select gateway & mode of payment.</li>
                        <li>The processing fee depends on the gateway & mode of payment.</li>
                        <li>If you are selecting cash @ bank as payment mode, please print acknowledgement slip.
                            Take note of the expiry date on the acknowledgement slip. </li>
                        <li>Multiple acknowledgement slips can be generated until the application expires. </li>
                    </ol>
                </div>
            </div>



            <div class="notice-section">
                <div class="notice-card">
                    <div class="notice-header">
                        <span class="notice-badge">Important Notice</span>
                        <h4 class="notice-title">Non-Refundable Payment</h4>
                    </div>
                    <div class="notice-body">
                        <p>
                            E-visa application fees are charged for processing and assessment services. Once payment has been made, it cannot be refunded, regardless of the outcome of the application. 
                        </p>
                        <p class="policy-note">
                            Please review the full policy before proceeding:
                        </p>
                        <p class="policy-link-container">
                            <a [href]="refundPolicyUrl" target="_blank" class="policy-link">Nigeria Immigration Refund Policy</a>
                        </p>
                    </div>
                </div>

                <div class="terms-acceptance">
                    <span class="acknowledgement-title">Acknowledgement:</span>
                    <label class="checkbox-wrapper">
                        <input type="checkbox" [(ngModel)]="termsAccepted" class="custom-checkbox">
                        <span class="checkbox-label">
                            By proceeding, I confirm that I have read and understood the refund policy, and I agree that this payment is final and non-refundable.
                        </span>
                    </label>
                </div>
            </div>

            <div class="action-container">
                <button type="submit" (click)="makePayment();" [disabled]="!selectedPaymentMode || !termsAccepted"
                    class="pay-button" [class.disabled]="!selectedPaymentMode || !termsAccepted">
                    Pay Now
                </button>
            </div>
        </div>
    </div>
</main>

<app-footer></app-footer>